import { api } from './BaseService'

export const getMeasurementFields = async () => {
    return await api.get(`/measurement_fields`)
}
export const getClientSizes = async (id) => {
    return await api.get(`/clients/size/${id}`)
}
export const getClientChilds = async (id) => {
    return await api.get(`/clients/childs/${id}`)
}
export const getMeasurementFieldById = async (id) => {
    return await api.get(`/measurement_fields/${id}`)
}

export const createMeasurementField = async (data) => {
    return await api.post(`/measurement_fields`, data)
}
export const updateMeasurementField = async (data) => {
    return await api.put(`/measurement_fields/${data?.id}`, data)
}
export const deleteMeasurementField = async (id) => {
    return await api.delete(`/measurement_fields/${id}`)
}
